import React from 'react'
import { connect } from 'react-redux'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import LoadingIndicator from '@/components/LoadingIndicator'
import { actionCreators } from '@/store/outputReportGroupDefinitions'
import OutputReportGroupDefinitionForm from './form'
import { Col, Row, Container } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { ReportInfo } from '@/internal-app/pages/outputReportGroupDefinitions/reportInfo'

@localized()
class OutputReportGroupDefinitionDetail extends React.Component {
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.props.match.params.id)
  }

  renderExternalReports (outputReportGroupDefinition) {
    if (!outputReportGroupDefinition) return

    const renderList = (externalReportsList, name) => {
      const reportsToRender = []

      for (let i = 0; i < externalReportsList.length; i++) {
        const externalReport = externalReportsList[i]

        const toRender = reportsToRender.find(x => x.sourceReport === externalReport.sourceReport)

        if (toRender == null) {
          reportsToRender.push({
            sourceReport: externalReport.sourceReport,
            reports: [ externalReport.targetReport ]
          })
        } else {
          toRender.reports.push(externalReport.targetReport)
        }
      }

      return <WhiteBox transparent header={<Resx name={name} />}>
        <Row>
          <Col sm='12'>{reportsToRender.map((x, i) => <Container fluid key={i}>
            <Row>
              <Col sm='12'><u><b>{x.sourceReport}</b></u>:</Col>
            </Row>
            <Row>
              {x.reports.map((d, ic) => <Col sm='4'>
                <ReportInfo reportCode={d} key={`${ic}-info`} />
                <span>,&nbsp;</span>
              </Col>)}
            </Row>
            <br />
          </Container>)}</Col>
        </Row>
      </WhiteBox>
    }

    return <React.Fragment>
      {!!outputReportGroupDefinition.externalReports &&
      !!outputReportGroupDefinition.externalReports.length &&
      renderList(outputReportGroupDefinition.externalReports, 'Reporting.ExternalReports')}
      {!!outputReportGroupDefinition.institutionReports &&
      !!outputReportGroupDefinition.institutionReports.length &&
      renderList(outputReportGroupDefinition.institutionReports, 'Reporting.InstitutionReports')}
    </React.Fragment>
  }

  renderDatasets (outputReportGroupDefinition) {
    if (!outputReportGroupDefinition ||
      !outputReportGroupDefinition.templateDatasets ||
      !outputReportGroupDefinition.templateDatasets.length) return

    const datasetsToRender = []

    for (let i = 0; i < outputReportGroupDefinition.templateDatasets.length; i++) {
      const dataset = outputReportGroupDefinition.templateDatasets[i]

      const toRender = datasetsToRender.find(x => x.reportTemplateCode === dataset.reportTemplateCode)

      if (toRender == null) {
        datasetsToRender.push({
          reportTemplateCode: dataset.reportTemplateCode,
          datasets: [dataset.datasetNumber]
        })
      } else {
        toRender.datasets.push(dataset.datasetNumber)
      }
    }

    return <WhiteBox transparent header={<Resx name='Reporting.Datasets' />}>
      <Row>
        <Col sm='12'>{datasetsToRender.map(x => <InfoRow>
          <InfoLabel>{x.reportTemplateCode}</InfoLabel>
          <InfoContent>{x.datasets.map(d => `${d}, `)}</InfoContent>
        </InfoRow>)}</Col>
      </Row>
    </WhiteBox>
  }

  render () {
    const { outputReportGroupDefinitions, update } = this.props
    const isLoading = outputReportGroupDefinitions.fetching || outputReportGroupDefinitions.updating

    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl='/output-report-definitions'>
            <Resx name='Reporting.OutputReportGroupDefinitionsTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          {isLoading && <LoadingIndicator />}
          {!isLoading && (
            <React.Fragment>
              <OutputReportGroupDefinitionForm
                outputReportGroupDefinition={outputReportGroupDefinitions.outputReportGroupDefinition}
                key={outputReportGroupDefinitions.componentKey}
                update={update}
              />
              {!!outputReportGroupDefinitions.outputReportGroupDefinition && this.renderDatasets(outputReportGroupDefinitions.outputReportGroupDefinition)}
              {!!outputReportGroupDefinitions.outputReportGroupDefinition && this.renderExternalReports(outputReportGroupDefinitions.outputReportGroupDefinition)}
            </React.Fragment>
          )}
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    outputReportGroupDefinitions: state.outputReportGroupDefinitions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  update: actionCreators.update
}

export default connect(mapStateToProps, mapDispatchToProps)(OutputReportGroupDefinitionDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGroupDefinitions/detail.js